import React from "react";
import "./App.css";
import RoutesPage from "./Routes/Routes";
import CommonHeader from "./Component/Element/CommonHeader";
const MainPage = (props) => {
  return (
    <>
      <CommonHeader
        gameMenuLink={props.gameMenuLink}
        gameMenuOverlay={props.gameMenuOverlay}
        gameMenuClick={props.gameMenuClick}
        removeGameMenu={props.removeGameMenu}
      />
      <RoutesPage />
    </>
  );
};

export default MainPage;
